<template>
  <b-sidebar
    id="sidebar-right-finance"
    :width="width"
    right
    backdrop
    body-class="p-0"
    no-header
    no-close-on-route-change
    no-close-on-backdrop
    lazy
    @hidden="closeFinanceSidebar"
  >
    <template #default="{ hide }">
      <div class="detail-widget">
        <div class="detail-widget__field detail-widget__left" v-if="!loading">
          <div class="detail-widget__top">
            <b-icon-arrow-bar-left
              class="detail-widget__back cursor-pointer"
              font-scale="2"
              @click="hide"
            />
            <b-skeleton-wrapper>
              <div class="top position-relative">
                <h2 class="title text-light mb-0">{{ detailedItem.invoice_number ? 'Детали счёта' : 'Счет' }}</h2>
                <p class="title-sub-invoice-number">{{ detailedItem.invoice_number ? `#${detailedItem.invoice_number}` : '#Без номера' }}</p>
              </div>
            </b-skeleton-wrapper>

            <button
              class="detail-widget__top-copy-button"
              @click="copyLink"
            >
              <b-icon
                icon="link45deg"
                scale="2"
              ></b-icon>
            </button>
          </div>

          <div class="detail-widget__card">
            <b-overlay class="h-100">
              <b-tabs
                lazy
                nav-class="nav-widget"
                nav-wrapper-class="p-0"
              >
                <b-tab @click="deleteQueryTab">
                  <template #title>
                    <div>Детали</div>
                  </template>
                  <tsoft-finance-details-client
                    :detailed-item="detailedItem"
                    :additional-data="additionalData"
                  />
                </b-tab>

                <b-tab :active="financeTab === 'finance-documents'">
                  <template #title>
                    <div>Документы</div>
                  </template>
                  <tsoft-show-edit-documents-client
                    :financeId="detailedItem.id"
                    :requestDocuments="detailedItem.id ? true : false"
                    :updateListDocument="singleOrMultiDocuments"
                  />
                </b-tab>
              </b-tabs>
            </b-overlay>
          </div>
        </div>

        <div v-else>
            <b-overlay
                :show="true"
                no-wrap
            >
                <template #overlay>
                    <div class="text-center text-success my-5">
                        <b-spinner variant="success"></b-spinner>
                    </div>
                    <div class="text-center">Ожидайте...</div>
                </template>
            </b-overlay>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapGetters } from 'vuex';
import tsoftFinanceDetailsClient from '@components/finance/FinanceDetailsClient';

import { mixinDocuments } from '@/mixins/mixinDocuments';
import { defaultDataItems } from '@/mixins/defaultDataItems';
import { copyLink } from '@/mixins';
import { API_FINANCE, API_FINANCE_PAYMENTS } from '@/constants';

export default {
  components: { tsoftFinanceDetailsClient },

  mixins: [
    mixinDocuments,
    defaultDataItems,
    copyLink,
  ],
  props: {
    width: {
      type: String,
      require: true,
    }
  },
  data() {
    return {
      loading: true,
      additionalData: {
        paidSumCurrency: 0
      },
      detailedItem: {},
      payments: {}
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    financeTab() {
      return this.$route.query['tab-finance'];
    },
  },
  methods: {
    loadOneItem() {
      api.call('get', `${API_FINANCE}/${+this.$route.query.finance}`).then(({data}) => {
        this.detailedItem = data;
        this.loading = false;
        this.loadPayments();
      })
    },
    loadPayments() {
      api.call('get', `${API_FINANCE_PAYMENTS}/?finance_id=${+this.$route.query.finance}`).then(({data}) => {
        this.payments = data.data;
      })
      .then(() => {
        this.calcPaidSummer()
      })
    },
    closeFinanceSidebar() {
      const query = Object.assign({}, this.$route.query);
      delete query.finance;
      delete query['edit-finance'];
      delete query['tab-finance'];
      this.$router.replace({ query });
    },
    deleteQueryTab() {
      if (this.$route.query['tab-finance']) {
        const query = Object.assign({}, this.$route.query);
        delete query['tab-finance'];
        this.$router.replace({ query });
      }
    },
    updateCurrencyPayments(sum) {
      this.additionalData.paidSumCurrency = sum
    },
    calcPaidSummer() {
      let sum = 0;
      this.payments.forEach((payment, index) => {
        if (payment['sum_currency'] !== null) {
          sum = parseFloat(sum) + parseFloat(payment['sum_currency'])
        } else {
          sum = parseFloat(sum) + parseFloat(payment['sum'])
        }
      })
      this.updateCurrencyPayments(sum);
    },
  },

  mounted() {
      this.loadOneItem();
    },
}
</script>

<style lang="scss" scoped>
$bg-top: #0d6247;

.top {
  display: flex;
  align-items: center;

  @media screen and (max-width: 991px) {
    flex-wrap: wrap;
    padding-top: 5px;
  }
}

.buttons {
  margin-left: auto;
  @media screen and (max-width: 991px) {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 20px;
    margin-left: -40px;
  }
}

.textarea-form {
  min-width: 400px;
  @media screen and (max-width: 991px) {
    min-width: 100%;
  }
}

.title {
  @media screen and (max-width: 991px) {
    font-size: 1rem;
    width: 100%;
  }
}

.subtitle {
  @media screen and (max-width: 991px) {
    font-size: 1.1rem;
    margin-left: -40px;
  }
}

.detail-widget {
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;

  @media screen and (max-width: 991px) {
    flex-direction: column;
    position: relative;
  }

  &__left {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    @media screen and (max-width: 991px) {
      min-height: 100vh;
    }
  }

  &__right {
    width: 100%;
    background-color: #f5f5f5;
    position: relative;
    @media screen and (max-width: 991px) {
      max-width: 100% !important;
    }

    &.collapses {
      transition: width 0.3s;
    }
  }

  &__top {
    position: relative;
    color: #fff;
    background-color: $bg-top;
    padding: 15px 1.5rem 15px 3rem;
    min-height: 110px;

    &-copy-button {
      position: absolute;
      top: 60px;
      left: 10px;
      border: none;
      outline: none;
      background-color: transparent;
      color: #fff;
    }
  }

  &__card {
    flex: 1;
    overflow-x: hidden;

    ::v-deep .tabs {
      display: flex;
      height: 100%;
      margin: 0;
      @media screen and (max-width: 991px) {
        flex-direction: column;
      }

      .nav-widget {
        background-color: $bg-top;
        height: 100%;
        flex-wrap: nowrap;
        overflow: auto;
        min-width: 130px;
        width: 100%;
        flex-direction: column;
        @media screen and (max-width: 991px) {
          flex-direction: row;
          height: auto;
          overflow-y: hidden;
        }
        .nav-link {
          text-align: left;
          border-radius: 0 !important;
          padding: 15px 10px !important;
          font-size: 14px !important;
          line-height: 1.1;
          font-weight: 700;
          color: #fff;
          min-width: 100px;
          border: none;
          text-transform: uppercase;
          @media screen and (max-width: 991px) {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            padding: 10px !important;
          }
          &.active {
            color: #000 !important;
            background-color: #fff;
          }
          &:hover {
            color: #000 !important;
            background: #fff;
          }
        }
      }

      .tab-content {
        overflow: auto;
        height: 100%;
        width: 100%;
        padding: 15px 22px;
        @media screen and (max-width: 991px) {
          overflow: inherit;
          padding: 15px 5px;
        }

        &::-webkit-scrollbar {
          width: 7px;
          border-radius: 0 !important;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 0 !important;
          cursor: pointer;
        }
      }
    }
  }

  &__back {
    font-size: 200%;
    position: absolute;
    left: 10px;
    top: 15px;
  }
}
.title-sub-invoice-number {
  position: absolute;
  top: 33px;
  left: 0;
  color: #f8f9fa;
  font-weight: bold;
  font-size: 1.8rem;
  margin: 0;

  @media screen and (max-width: 991px) {
    margin-top: 8px;
    font-size: 1.1rem;
  }
}
</style>